import { RandomUIDGenerator } from "../random/RandomUIDGenerator";
import { AttributeValue } from "./AttributeValue";
import { ElementAttribute } from "./ElementAttribute";


export class DomID
{
  static readonly attribute = new ElementAttribute( "-dom--id" );


  static getAttributeValue( element:Element )
  {
    return new AttributeValue( DomID.attribute, DomID.get( element ) );
  }

  static get( element:Element )
  {
    if ( ! element )
    {
      return null;
    }

    this.ensure( element );

    return DomID.attribute.from( element );
  }


  static ensure( element:Element )
  {
    if ( DomID.attribute.in( element ) )
    {
      return;
    }    

    DomID.attribute.to( element, RandomUIDGenerator.createUID() )

  }
}